module.exports = new __parcel__URL__("unassignedAvatar.299fb7bf.svg").toString();